var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 441,
    viewBox: "0 0 366 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.477 298.263C297.746 344.298 238.069 390.381 178.346 436.417C168.776 443.839 155.055 442.052 147.591 432.466C103.528 375.739 78.1841 333.654 31.9149 275.243C20.7164 259.344 -0.26742 224.312 0.0025805 177.277C0.473993 96.6434 63.0423 47.7088 74.2386 38.973C108.102 12.4308 143.118 3.41361 162.623 0C236.656 95.1722 288.814 173.279 361.423 267.349C368.835 276.928 367.051 290.841 357.478 298.263H357.477Z",
    fill: "url(#paint0_linear_1620_811)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1620_811",
    x1: 0,
    y1: 0,
    x2: 285.226,
    y2: 398.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D76AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3148"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionBg3);
export default __webpack_public_path__ + "static/media/section-bg-3.25afc6f62823af6ab64f93c57c2b7ae5.svg";
export { ForwardRef as ReactComponent };